import React, { useRef, useState } from 'react';
import Alert from 'react-bootstrap/Alert';

const Result = () => {
    return (
        <Alert variant="success" className="success-msg">
            Your quote request has been successfully sent
        </Alert>
    );
};

const ContactForm = () => {
    const form = useRef();
    const [result, showResult] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const submitToApi = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        const formData = new FormData(form.current);
        
        // Prepare data for API
        const data = {
            name: formData.get('contact-name'),
            email: formData.get('contact-email'),
            phone: formData.get('contact-phone'),
            message: formData.get('contact-message'),
            type: "Contact us" // Adding the required type field
        };

        try {
            const response = await fetch('https://ucwf-server-42s2.onrender.com/api/application/quote', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (response.ok) {
                form.current.reset();
                showResult(true);
                setTimeout(() => showResult(false), 5000);
            } else {
                setError(result.message || 'Error submitting form');
            }
        } catch (error) {
            console.error('Error:', error);
            setError('Failed to connect to the server. Please try again later.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form ref={form} onSubmit={submitToApi} className="axil-contact-form">
            <div className="form-group">
                <label>Name</label>
                <input type="text" className="form-control" name="contact-name" required />
            </div>
            <div className="form-group">
                <label>Email</label>
                <input type="email" className="form-control" name="contact-email" required />
            </div>
            <div className="form-group">
                <label>Phone</label>
                <input type="tel" className="form-control" name="contact-phone" required />
            </div>
            <div className="form-group mb--40">
                <label>How can we help you?</label>
                <textarea className="form-control" name="contact-message" rows="4"></textarea>
            </div>
            <div className="form-group">
                <button 
                    type="submit" 
                    className="axil-btn btn-fill-primary btn-fluid btn-primary"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Sending...' : 'Send Enquiry'}
                </button>
            </div>
            <div className="form-group">
                {result ? <Result /> : null}
                {error && <Alert variant="danger">{error}</Alert>}
            </div>
        </form>
    );
};

export default ContactForm;